<app-loader [isLoading]="isLoading"></app-loader>

<div class="the_container">
  <div class="d-flex justify-content-between mob-view">
    <span class="details-text">Mandir Bill Settlement Report</span>
    <div class="filter-div">
      <mat-form-field class="select-mat-form-field custom-select-form select-width">
        <mat-select class="custom-mat-select custom-select" placeholder="Financial Year" [formControl]="currentFY">
          @for (item of fyList; track item) {
          <mat-option [value]="item.key">{{ item.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="dashboard-header">
    <div class="row">
      <div class="col-md-12">
        <div class="bredcrumb">
          <ng-container *ngFor="let crumb of breadcrumbs; let last = last">
            <span (click)="onClickBreadcrumb(crumb)"
              [ngClass]="!last ? 'brancd-prime me-2 cursor-pointer' : 'text-disable me-2'">{{ crumb }}</span>
            <img *ngIf="!last" src="../../assets/images/chevron.svg" class="me-2" />
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="custom-dropdown">
    <input class="search-input dp-input-control" [style.margin-bottom]="isMobileDevice?'16px':'0px'" type="text"
      [formControl]="searchTerm" placeholder="Search by Anything" aria-label="Search" />
  </div>

  <div class="table-container">
    @if (selectedState === '') {
    <table class="table">
      <thead class="table-head">
        <tr>
          <th><span>State</span></th>
          <th><span>Total Mandirs</span></th>
          <!-- <th><span>Total Advance</span></th>
            <th><span>Remaining Amount</span></th> -->
        </tr>
      </thead>
      <tbody class="table-body">
        @for (row of updatedData; track row) {
        <tr>
          <td data-label="State" class="hover-item" (click)="onClickState(row.state_name)">
            {{ row.state_name }}
          </td>
          <td data-label="Total Mandirs">{{ row.total_mandirs }}</td>
          <!-- <td data-label="Total Advance">{{ fmt(row.total_advance) }}</td>
              <td data-label="Remaining Amount">{{ fmt(row.remaining_amount) }}</td> -->
        </tr>
        }
        @if (updatedData.length === 0 && !isLoading) {
        <tr>
          <td colspan="4" class="no-records">No records found</td>
        </tr>
        }
      </tbody>
    </table>
    } @else {

    @if (!selectedDistrict) {
    <table class="table">
      <thead class="table-head">
        <tr>
          <th><span>State</span></th>
          <th><span>District</span></th>
          <th><span>Total Mandirs</span></th>
        </tr>
      </thead>
      <tbody class="table-body">
        @for (row of updatedData; track row) {
        <tr>
          <td data-label="State">{{ row.state_name }}</td>
          <td data-label="District" class="hover-item" (click)="onClickDistrict(row)">
            {{ row.district_name }}
          </td>
          <td data-label="Total Mandirs" class="hover-item" (click)="onClickDistrict(row)">
            {{ row.total_mandirs }}
          </td>
        </tr>
        }
        @if (updatedData.length === 0 && !isLoading) {
        <tr>
          <td colspan="3" class="no-records">No records found</td>
        </tr>
        }
      </tbody>
    </table>
    }

    @else {
    <table class="table">
      <thead class="table-head">
        <tr>
          <th><span>Mandir Name</span></th>
          <th><span>Code</span></th>
          <th><span>Last Advance Date</span></th>
          <th><span>Last Bill Date</span></th>
          <th><span>Advance Taken</span></th>
          <th><span>Bill Provided</span></th>
          <th><span>Unsettled</span></th>
          <th><span>Contact</span></th>
        </tr>
      </thead>

      <tbody class="table-body">
        @for (row of updatedData; track row) {
        <tr>
          <td data-label="Mandir Name">{{ row.scoa_name }}</td>
          <td data-label="Code">{{ row.scoa_code }}</td>
          <td data-label="Last Advance Date">{{ row.last_advance_date || '--' }}</td>
          <td data-label="Last Bill Date">{{ row.last_bill_receive_date || '--' }}</td>
          <td data-label="Advance Taken">
            <span [class.clickable]="isValidAmount(row.total_advance_given)"
              (click)="isValidAmount(row.total_advance_given) && openAdvanceDetails(row)">
              {{ fmt(row.total_advance_given) }}
            </span>
          </td>
          <td data-label="Bill Provided">
            <span [class.clickable]="isValidAmount(row.total_bill_payment)"
              (click)="isValidAmount(row.total_bill_payment) && openBillDetails(row)">
              {{ fmt(row.total_bill_payment) }}
            </span>
          </td>
          <td data-label="Unsettled">{{ fmt(row.remaining_amount) }}</td>
          <td data-label="Contact">
            <button class="dp-secondary-btn p-1">
              Contact
            </button>
          </td>
        </tr>
        }

        @if (updatedData.length === 0 && !isLoading) {
        <tr>
          <td colspan="8" class="no-records">No records found</td>
        </tr>
        }
      </tbody>
    </table>
    }
    }
  </div>
</div>
